import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {flexAbsoluteCenter, mb} from "@pg-design/helpers-css";
import {consoleError} from "@pg-mono/logger";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchDistrictsWithCheck} from "../actions/fetch_districts_with_check";
import {ButtonLink} from "../atoms/ButtonLink";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import type {IDistrictData} from "../components/prices_map/PricesMapDistricts";
import {PricesBigDataReferral} from "../components/PricesBigDataReferral";
import {PricesChart} from "../components/PricesChart";
import {PricesCityInfo} from "../components/PricesCityInfo";
import {PricesExpert} from "../components/PricesExpert";
import {PricesHeader} from "../components/PricesHeader";
import {PricesLinks} from "../components/PricesLinks";
import {PRICES_CITIES_WITHOUT_DISTRICT_MAP_SLUGS, PricesMap} from "../components/PricesMap";
import {PricesRegionsFAQ} from "../components/PricesRegionsFAQ";
import {PricesViewType} from "../helpers/prices_view_type";

interface Props {
    type: PricesViewType;
    region: IRegionReportPrice;
}

const findMinAndMaxDistricts = (districtsData: IDistrictData[]) => {
    if (districtsData.length === 0) {
        return {min: null, max: null};
    }

    return districtsData.reduce(
        (acc, item) => {
            if (item.avg_price_m2 < acc.min.avg_price_m2) {
                acc.min = item;
            }
            if (item.avg_price_m2 > acc.max.avg_price_m2) {
                acc.max = item;
            }
            return acc;
        },
        {min: districtsData[0], max: districtsData[0]}
    );
};

export const PricesRegionLayout = (props: Props) => {
    const [districtsData, setDistrictData] = useState<IDistrictData[]>([]);
    const [minDistrict, setMinDistrict] = useState<IDistrictData | null>(null);
    const [maxDistrict, setMaxDistrict] = useState<IDistrictData | null>(null);

    const pricesAvailableDate = useSelector((store: IRPStore) => store.report.price.pricesAvailableDate);

    useEffect(() => {
        if (PRICES_CITIES_WITHOUT_DISTRICT_MAP_SLUGS.includes(props.region.slug)) {
            return;
        }

        fetchDistrictsWithCheck({regionSlug: props.region.slug, type: props.type, date: pricesAvailableDate?.date})
            .then((response) => {
                setDistrictData(response);
            })
            .catch((error) => {
                consoleError("fetchDistrictsData error: ", error);
            });
    }, []);

    useEffect(() => {
        const {min, max} = findMinAndMaxDistricts(districtsData);

        setMinDistrict(min);
        setMaxDistrict(max);
    }, [districtsData]);

    return (
        <div>
            <PricesBreadcrumbs type={props.type} region={props.region} />

            <PricesHeader type={props.type} region={props.region} />

            <PricesChart type={props.type} region={props.region} />

            <PricesMap region={props.region} type={props.type} />

            <PricesBigDataReferral />

            <PricesCityInfo region={props.region} />

            <PricesRegionsFAQ minDistrict={minDistrict} maxDistrict={maxDistrict} region={props.region} />

            <PricesExpert expertOpinion={props.region.landing_page_expert_opinion} />

            <Container css={[flexAbsoluteCenter, mb(5)]}>
                <ButtonLink slug={props.region.slug} />
            </Container>

            <PricesLinks type={props.type} region={props.region} />
        </div>
    );
};
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";

import {Container} from "@pg-design/grid-module";
import {flexAbsoluteCenter, mb} from "@pg-design/helpers-css";
import {consoleError} from "@pg-mono/logger";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchDistrictsWithCheck} from "../actions/fetch_districts_with_check";
import {ButtonLink} from "../atoms/ButtonLink";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import type {IDistrictData} from "../components/prices_map/PricesMapDistricts";
import {PricesBigDataReferral} from "../components/PricesBigDataReferral";
import {PricesChart} from "../components/PricesChart";
import {PricesCityInfo} from "../components/PricesCityInfo";
import {PricesExpert} from "../components/PricesExpert";
import {PricesHeader} from "../components/PricesHeader";
import {PricesLinks} from "../components/PricesLinks";
import {PRICES_CITIES_WITHOUT_DISTRICT_MAP_SLUGS, PricesMap} from "../components/PricesMap";
import {PricesRegionsFAQ} from "../components/PricesRegionsFAQ";
import {PricesViewType} from "../helpers/prices_view_type";

interface Props {
    type: PricesViewType;
    region: IRegionReportPrice;
}

const findMinAndMaxDistricts = (districtsData: IDistrictData[]) => {
    if (districtsData.length === 0) {
        return {min: null, max: null};
    }

    return districtsData.reduce(
        (acc, item) => {
            if (item.avg_price_m2 < acc.min.avg_price_m2) {
                acc.min = item;
            }
            if (item.avg_price_m2 > acc.max.avg_price_m2) {
                acc.max = item;
            }
            return acc;
        },
        {min: districtsData[0], max: districtsData[0]}
    );
};

export const PricesRegionLayout = (props: Props) => {
    const [districtsData, setDistrictData] = useState<IDistrictData[]>([]);
    const [minDistrict, setMinDistrict] = useState<IDistrictData | null>(null);
    const [maxDistrict, setMaxDistrict] = useState<IDistrictData | null>(null);

    const pricesAvailableDate = useSelector((store: IRPStore) => store.report.price.pricesAvailableDate);

    useEffect(() => {
        if (PRICES_CITIES_WITHOUT_DISTRICT_MAP_SLUGS.includes(props.region.slug)) {
            return;
        }

        fetchDistrictsWithCheck({regionSlug: props.region.slug, type: props.type, date: pricesAvailableDate?.date})
            .then((response) => {
                setDistrictData(response);
            })
            .catch((error) => {
                consoleError("fetchDistrictsData error: ", error);
            });
    }, []);

    useEffect(() => {
        const {min, max} = findMinAndMaxDistricts(districtsData);

        setMinDistrict(min);
        setMaxDistrict(max);
    }, [districtsData]);

    return (
        <div>
            <PricesBreadcrumbs type={props.type} region={props.region} />

            <PricesHeader type={props.type} region={props.region} />

            <PricesChart type={props.type} region={props.region} />

            <PricesMap region={props.region} type={props.type} />

            <PricesBigDataReferral />

            <PricesCityInfo region={props.region} />

            <PricesRegionsFAQ minDistrict={minDistrict} maxDistrict={maxDistrict} region={props.region} />

            <PricesExpert expertOpinion={props.region.landing_page_expert_opinion} />

            <Container css={[flexAbsoluteCenter, mb(5)]}>
                <ButtonLink slug={props.region.slug} />
            </Container>

            <PricesLinks type={props.type} region={props.region} />
        </div>
    );
};
